<div class="progress-bar" >
    <div class="progress-bar-status">{{porcentajeSubida == '100%' ? mensjeCompletado: mensjeProgreso}}
      <div *ngIf="textoLink.length>0" class="link" ><a id="a-link" [routerLink]=""(click)="click()">{{textoLink}}</a>
      </div>
    </div>
    <div class="progress-bar-bar"><span [ngStyle]="{'width': porcentajeSubida}"></span></div>
</div>
